import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { reducer } from './reducer';
import { NavbarStoreEffects } from './effects';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('navbar', reducer),
        EffectsModule.forFeature([NavbarStoreEffects]),
    ],
    providers: [],
})
export class NavbarStoreModule {}
